<template lang="pug">
  p#globaltitle(:class="lang")
    a(:href='path')
      |{{title}}

</template>
<script>
  import {mapState} from 'vuex';

  export default{
    computed: {
      ...mapState([
        'site_title',
        'site_path',
        'lang',
      ]),
      title(){
        if(/ja/.test(this.lang)){
          return this.site_title.ja;
        }else{
          return this.site_title.en;
        }
      },
      path(){
        if(/ja/.test(this.lang)){
          return this.site_path;
        }else{
          return this.site_path.prefix + this.site_path;
        }
      },
    }
  }
</script>